import React from "react";
import { CButton, CButtonGroup, CFormLabel } from "@coreui/react";

/**
 * Переключатель группировки OLAP: по дням (по умолчанию) или по группам ресторанов.
 */
export default function GroupByToggle({ value, onChange, disabled, className = "", id = "groupByToggle" }) {
  return (
    <div className={className}>
      <CFormLabel htmlFor={id} className="small text-body-secondary mb-1">
        Группировка
      </CFormLabel>
      <CButtonGroup role="group" id={id} aria-label="Группировка статистики">
        <CButton
          type="button"
          color="primary"
          size="sm"
          variant={!value ? undefined : "outline"}
          disabled={disabled}
          onClick={() => onChange(false)}
        >
          По дням
        </CButton>
        <CButton
          type="button"
          color="primary"
          size="sm"
          variant={value ? undefined : "outline"}
          disabled={disabled}
          onClick={() => onChange(true)}
        >
          По группам
        </CButton>
      </CButtonGroup>
    </div>
  );
}
